import { FhsAxios } from "../../services/axios";

export default {
  state: {
    brokersList: [],
    selectedBroker: "all"
  },
  actions: {
    fetchBrokersList({ commit, getters }) {
      FhsAxios.post("broker/list", {}).then(response => {
        commit("setBrokersList", response.data.result.brokers);
      });
    },
    changeSelectedBroker({ commit, dispatch }, brokerId) {
      // Изменяем выбранного брокера
      commit("setSelectedBroker", brokerId);
      // Присваиваем vp значение null, чтобы показался прелоадер
      commit("unsetVp");
      // Присваиваем unsetCurrencyPortfolio значение null, чтобы показался прелоадер
      commit("unsetCurrencyPortfolio");
      // Присваиваем incomeData значение null, чтобы показалася прелоадер
      commit("unsetIncomeData");
      // Присваиваем assetDynamics значение null, чтобы показался прелоадер
      commit("unsetAssetDynamics");
      // Присваиваем userPortfolio значение null, чтобы показалася прелоадер
      commit("unsetUserPortfolio");
      // Присваиваем transactions значение null, чтобы показалася прелоадер
      commit("unsetTransactions");
      // Присваиваем instructionsList значение null, чтобы показалася прелоадер
      commit("unsetInstructionsList");
      commit("unsetUserBalance");
      commit("unsetTotalMoneyInTenge");
      // Загружаем данные по выбранному брокеру
      dispatch("fetchIncomeSinceYearBeginning");
      // dispatch("fetchAccountData");
      dispatch("fetchUserData");
      dispatch("fetchIncomeData");
      dispatch("fetchAssetDynamics");
      dispatch("fetchUserPortfolio");
      dispatch("fetchTransactions");
      dispatch("fetchInstructions");
    }
  },
  mutations: {
    setBrokersList(state, brokersList) {
      // Отлавливаем ошибку на сервере, когда не прилетает brokersList
      if (!Array.isArray(brokersList)) {
        brokersList = [];
      }
      brokersList.unshift({ BROKER_ID: "all", BROKER_NAME: "Все брокеры" });
      state.brokersList = brokersList;
    },
    setSelectedBroker(state, brokerId) {
      state.selectedBroker = brokerId;
    }
  },
  getters: {
    brokersList(state) {
      let brokersList = state.brokersList || [];
      return brokersList.map(broker => {
        if (broker.BROKER_ID === state.selectedBroker) {
          return {
            value: broker.BROKER_ID,
            text: broker.BROKER_NAME,
            selected: true
          };
        }
        return {
          value: broker.BROKER_ID,
          text: broker.BROKER_NAME
        };
      });
    },
    selectedBroker(state) {
      return state.selectedBroker;
    }
  }
};
